import Vue from 'vue';
import './loading.component.scss';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ConfigUtils from '@/common/utils/config.util';

@Component({})
export default class LoadingComponent extends Vue {
  // prop data
  @Prop({ default: true }) isActive!: boolean;

  // render
  render() {
    return (
      <div
        class={{
          'loading-wrapper': true,
          'is-active': this.isActive && ConfigUtils.isEnableLoadingMode()
        }}
      >
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}
